import { Layout } from "@jambushrushti/components/layout/Layout";
import { Input } from "@jambushrushti/components/ui/input";
import { Button } from "@jambushrushti/components/ui/button";
import { Card, CardContent } from "@jambushrushti/components/ui/card";
import {
  Search as SearchIcon,
  BookOpen,
  FileText,
  Users,
  Scroll,
} from "lucide-react";
import { useState } from "react";

export default function Search() {
  const [query, setQuery] = useState("");

  return (
    <Layout>
      <section className="py-16 lg:py-24">
        <div className="container mx-auto px-4">
          <div className="mx-auto mb-12 max-w-3xl text-center">
            <h1 className="font-display mb-4 text-4xl font-bold text-foreground lg:text-5xl">
              Search Jambushrusti
            </h1>
            <p className="text-lg text-muted-foreground">
              Find books, manuscripts, research entries, and Guruvani across our
              entire ecosystem.
            </p>
          </div>

          {/* Search Input */}
          <div className="mx-auto mb-12 max-w-2xl">
            <div className="relative">
              <SearchIcon className="absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-muted-foreground" />
              <Input
                type="text"
                placeholder="Search for books, manuscripts, research, Guruvani..."
                className="rounded-full border-2 border-border py-6 pl-12 pr-4 text-lg focus:border-primary"
                value={query}
                onChange={e => setQuery(e.target.value)}
              />
              <Button
                variant="hero"
                className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full"
              >
                Search
              </Button>
            </div>
          </div>

          {/* Quick Search Categories */}
          <div className="mx-auto max-w-4xl">
            <h2 className="font-display mb-6 text-center text-xl font-semibold text-foreground">
              Browse by Category
            </h2>
            <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
              <Card className="hover:shadow-soft group cursor-pointer transition-all duration-300">
                <CardContent className="p-6 text-center">
                  <BookOpen className="mx-auto mb-3 h-10 w-10 text-primary transition-transform group-hover:scale-110" />
                  <h3 className="font-medium text-foreground">Books</h3>
                  <p className="text-sm text-muted-foreground">
                    Library catalog
                  </p>
                </CardContent>
              </Card>
              <Card className="hover:shadow-soft group cursor-pointer transition-all duration-300">
                <CardContent className="p-6 text-center">
                  <FileText className="mx-auto mb-3 h-10 w-10 text-gold transition-transform group-hover:scale-110" />
                  <h3 className="font-medium text-foreground">Manuscripts</h3>
                  <p className="text-sm text-muted-foreground">Ancient texts</p>
                </CardContent>
              </Card>
              <Card className="hover:shadow-soft group cursor-pointer transition-all duration-300">
                <CardContent className="p-6 text-center">
                  <Scroll className="text-sage mx-auto mb-3 h-10 w-10 transition-transform group-hover:scale-110" />
                  <h3 className="font-medium text-foreground">Guruvani</h3>
                  <p className="text-sm text-muted-foreground">
                    Sacred teachings
                  </p>
                </CardContent>
              </Card>
              <Card className="hover:shadow-soft group cursor-pointer transition-all duration-300">
                <CardContent className="p-6 text-center">
                  <Users className="mx-auto mb-3 h-10 w-10 text-secondary-foreground transition-transform group-hover:scale-110" />
                  <h3 className="font-medium text-foreground">Research</h3>
                  <p className="text-sm text-muted-foreground">
                    Scholarly works
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
